import React from 'react'

const About = () => (
  <section className="ts-intro-item section-bg">
    <a id="about" className="anchor" />
    <div className="container">
      <div className="row">
        <div
          className="col-lg-4 wow fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay="300ms"
        >
          <div className="intro-left-content">
            <h2 className="column-title">
              <span>About</span>
              SRE NEXTとは？
            </h2>
            <p>
              SRE によるコミュニティベースのカンファレンスです。
              同じくコミュニティベースのSRE勉強会である
              <a href="https://sre-lounge.connpass.com/" target="_blank">
                「SRE Lounge」
              </a>
              のメンバーが中心となり運営・開催されます。
            </p>
            {/*<a href="#" className="btn">
              Buy Ticket
            </a>*/}
          </div>
        </div>
        <div className="col-lg-8">
          <div className="row">
            <div
              className="col-lg-12 wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="400ms"
            >
              <div className="single-intro-text mb-30">
                <i className="icon icon-light-bulb" />
                <h3 className="ts-title">SREとは</h3>
                <p>
                  Googleにより提唱された、システム管理とサービス運用における考え方または方法論であり、それらを実践するエンジニアを指します。
                  SREは、サービスやインフラの信頼性をソフトウェアエンジニアリングによって実現することを目指します。
                  サービスの信頼性を重視する多くの企業において取り入れられており、近年ますますその広がりを見せています。
                </p>
                <span className="count-number">01</span>
              </div>
            </div>
            <div
              className="col-lg-12 wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="500ms"
            >
              <div className="single-intro-text mb-30">
                <i className="icon icon-speaker" />
                <h3 className="ts-title">セッションについて</h3>
                <p>
                  招待・公募を含め、幅広い企業の第一線でSREとして活躍されている方々をお招きし、現場における生の課題や解決策が垣間見えるセッションを多く揃えます。
                  SREの取り組みには決められた正解がないため、各社のSREはときに手探りで実践しています。そのようなノウハウが一堂に集まる本カンファレンスはSREを実践する多くのエンジニアにとって有益なものになると信じています。
                </p>
                <span className="count-number">02</span>
              </div>
            </div>
            <div
              className="col-lg-12 wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="600ms"
            >
              <div className="single-intro-text mb-30">
                <i className="icon icon-people" />
                <h3 className="ts-title">スポンサーについて</h3>
                <p>
                  このたびスポンサーにご協賛頂いた企業・団体様にお礼申し上げます。
                </p>
                <ul className="sponsor-list">
                  <li>
                    <a
                      href="https://docs.google.com/document/d/1xqgx8M8rsyDTA-DY12Xp11IDGKOKODxjIIGActSVZTQ/"
                      target="_blank"
                    >
                      スポンサー募集要項
                    </a>
                  </li>
                  <li>
                    <a href="./notice/">スポンサーへのお知らせ</a>
                  </li>
                </ul>
                <p>
                  疑問点やご相談があれば、お気軽に sre.next
                  <span className="atmark" />
                  gmail.com までお問い合わせください。
                </p>
                <span className="count-number">03</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default About
